export const APPLICATION_PAYMENT_ID =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    ? 'sandbox-sq0idb-G0ZBvcpZj2M00GQIRBvC9g'
    : 'sq0idp-_5Jw9FU05UMmB-cq16VRuw';
export const LOCATION_ID =
  !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    ? 'L6Y5JD8X3XF7V'
    : 'LW17YHAYN7YQQ';
